import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

interface UserState {
  user: any;
  updateUser: (user: any) => void;
  setUser: (user: any) => void;
  accessToken: string;
  setAccessToken: (token: string) => void;
  isLogedIn: boolean;
  setIsLogedIn: (newState: boolean) => void;
  patenteLessons: any;
  setPatenteLessons: (newState: any) => void;
  chapters: any[];
  setChapters: (newState: any[]) => void;
  clearUserStore: () => void;
}

const useUserStore = create<UserState>()(
  devtools(
    persist(
      (set, get) => ({
        user: {},
        setUser: (user) => set(() => ({ user: user })),
        updateUser: (user) =>
          set((state) => ({ user: { ...state.user, ...user } })),
        accessToken: "",
        setAccessToken: (token) => set(() => ({ accessToken: token })),
        isLogedIn: false,
        setIsLogedIn: (newState) => set((state) => ({ isLogedIn: newState })),
        patenteLessons: {
          id: 0,
          description: "",
          name: "",
          price: 0,
          user_has_course: false,
          lessons: [],
        },
        setPatenteLessons: (newState) =>
          set((state) => ({ patenteLessons: newState })),
        chapters: [],
        setChapters: (newState) => set((state) => ({ chapters: newState })),
        clearUserStore: () =>
          set((state) => ({
            user: {},
            accessToken: "",
            isLogedIn: false,
            patenteLessons: {
              ...state.patenteLessons,
              user_has_course: false,
            },
          })),
      }),
      {
        name: "user-storage",
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);

export default useUserStore;
